import { render, staticRenderFns } from "./dashFinanceiro.vue?vue&type=template&id=4a7fae94&scoped=true&"
import script from "./dashFinanceiro.vue?vue&type=script&lang=js&"
export * from "./dashFinanceiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7fae94",
  null
  
)

export default component.exports